export default "/_nuxt/61c438d01c4b5e9e8ed8f77e39540f46.svg";